import { Component, Input, NgZone, OnInit, ViewChild, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { IonInput } from '@ionic/angular';
@Component({
  selector: 'app-currency-input',
  templateUrl: './currency-input.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CurrencyInputComponent),
      multi: true
    }
  ]
})
export class CurrencyInputComponent implements ControlValueAccessor, OnInit {
  @ViewChild('amountInput', { static: false }) amountInput: IonInput;
  debounce: any;
  constructor(private ngZone: NgZone) { }
  @Input() formControlName: string = '';
  value: number | null = null;
  formControl: FormControl = new FormControl();

  onChange: any = () => { };
  onTouch: any = () => { };
  private formattedValue: string | null = null;

  ngOnInit() {
    if (!this.formControl) {
      this.formControl = new FormControl();
    }
    setTimeout(() => {
      this.amountInput.setFocus();
    }, 1000);
  }

  private updateFormattedValue() {
    // Si ya existe un temporizador, lo cancelamos
    if (this.debounce) {
      clearTimeout(this.debounce);
    }
    this.debounce = setTimeout(() => {
      if (this.value !== null) {
        // Cambia 'USD' según sea necesario
        this.formattedValue = new Intl.NumberFormat('es-MX', {
          style: 'currency',
          currency: 'MXN',
        }).format(this.value);
      } else {
        this.formattedValue = null
      }
    }, 1500);
  }

  writeValue(value: any): void {
    this.value = value;
    this.formControl.setValue(value);
    this.updateFormattedValue();
  }

  getFormattedValue(): string | null {
    return this.formattedValue;
  }

  updateValue(data: string): void {
    if (!isNaN(this.value) && data.length > 0) {
      let inputValue = data.replace(/[^\d.-]/g, '');
      inputValue = this.limitDecimals(inputValue, 2); // Limitar a dos decimales

      this.ngZone.run(() => {
        this.value = parseFloat(inputValue);
        this.formControl.setValue(this.value);
        this.updateFormattedValue();
        this.onChange(this.value); // Emitir evento de cambio
        this.onTouch(); // Marcar como "touched"
      });
    }
  }

  numericOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  private limitDecimals(value: string, maxDecimals: number): string {
    const parts = value.split('.');
    const integerPart = parts[0];
    let decimalPart = parts[1] || '';

    if (decimalPart.length > maxDecimals) {
      decimalPart = decimalPart.slice(0, maxDecimals);
    }

    return decimalPart ? `${integerPart}.${decimalPart}` : integerPart;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.formControl.disable();
    } else {
      this.formControl.enable();
    }
  }
}